import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loadTableViewFromTableQuery from '../../tables/loadTableViewFromTableQuery';

let isFirstRun = true;

const FIVE_MINUTES_IN_MILLISECONDS = 5 * 60 * 1000;

/**
 * Checks if the user account is newly created or not based on the MailboxCreateDate
 * Move to common utils folder if necessary
 * @returns boolean
 */
const isBrandNewUser = (): boolean => {
    const { MailboxCreateDate } = getUserConfiguration();

    if (MailboxCreateDate) {
        return Date.now() < FIVE_MINUTES_IN_MILLISECONDS + new Date(MailboxCreateDate).getTime();
    }

    // All newly created accounts would have the MailboxCreateDate. It's absence indicates it's an old account.
    return false;
};

/**
 * Fetches the emails for the selected table view on first launch of mail module.
 * First load of mail-list uses the data sent along the startup-data response.
 * For a newly created account however, welcome email may not be part of this response.
 * So, we need to perform a manual fetch to retrieve any emails that were received since the startup-data
 * call and before subscribing to SSE.
 */
export const loadInitialTableViewOnFirstRun = () => {
    try {
        if (isFirstRun && isBrandNewUser()) {
            const { tableQuery } = getCurrentSelectedTableView();
            loadTableViewFromTableQuery(tableQuery, null, null, {
                shouldPrefetchFirstNRows: false,
            });
        }

        isFirstRun = false;
    } catch (error) {}
};
